export function getCampaignDetails(quickCode) {
  return fetch(
    `${process.env.REACT_APP_BASE_API_URL}/Campaign/GetByQuickCode?quickCode=${quickCode}`
  ).then((data) => {
    let campaign = data.json();
    return campaign;
  });
}
